<script setup lang="ts">
import { useClock } from '@nsftx/seven-nxg-retail-vue-sdk'

const { date, time } = useClock({ locale: 'sr-RS', interval: 5000 })
</script>

<template>
  <div class="ss-footer-clock ss-d-flex-column">
    <span class="ss-footer-clock__time">
      {{ time }}
    </span>
    <span class="ss-footer-clock__date">
      {{ date }}
    </span>
  </div>
</template>

<style lang="scss" scoped>
@use '@/styles/mixins' as mixins;

.ss-footer-clock {
  padding-inline: var(--nxgds-alias-spacing-xs);

  &__time {
    @include mixins.typography('label-strong');
    color: var(--nxgds-mapped-color-text-primary);
  }

  &__date {
    @include mixins.typography('caption-regular');
    color: var(--nxgds-mapped-color-text-disabled);
  }
}
</style>
